import { Box, TextField, MenuItem, Button, Typography } from "@mui/material";
import { APP_PALETTE } from "../../theme/palette";

export default function SearchBar({
  search,
  onSearchChange,
  filters = [],
  onClear,
  resultCount,
}) {
  const hasActiveFilters = search || filters.some((f) => f.value && f.value !== f.defaultValue);

  return (
    <Box sx={{
      background: APP_PALETTE.surface,
      borderRadius: 3,
      p: 2,
      mb: 2,
      boxShadow: "0 1px 8px rgba(0,0,0,0.08)",
      display: "flex",
      gap: 1.5,
      flexWrap: "wrap",
      alignItems: "center",
    }}>
      <TextField
        size="small"
        placeholder="Buscar..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ width: { xs: "100%", sm: 240 }, minWidth: { xs: 0, sm: 240 }, flex: { xs: "1 1 100%", sm: "0 0 240px" } }}
      />

      {filters.map((f) =>
        f.type === "select" ? (
          <TextField
            key={f.key}
            select
            size="small"
            value={f.value}
            onChange={(e) => f.onChange(e.target.value)}
            sx={{ width: { xs: "100%", sm: f.width || 180 }, minWidth: { xs: 0, sm: f.width || 180 }, flex: { xs: "1 1 100%", sm: `0 0 ${f.width || 180}px` } }}
            label={f.label}
          >
            {f.options.map((o) => (
              <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
            ))}
          </TextField>
        ) : f.type === "date" ? (
          <TextField
            key={f.key}
            size="small"
            type="date"
            label={f.label}
            InputLabelProps={{ shrink: true }}
            value={f.value}
            onChange={(e) => f.onChange(e.target.value)}
            sx={{ width: { xs: "100%", sm: 180 }, minWidth: { xs: 0, sm: 180 }, flex: { xs: "1 1 100%", sm: "0 0 180px" } }}
          />
        ) : null
      )}

      {hasActiveFilters && onClear && (
        <Button size="small" onClick={onClear} sx={{ width: { xs: "100%", sm: "auto" }, color: APP_PALETTE.text.secondary }}>
          Limpiar
        </Button>
      )}

      {resultCount !== undefined && (
        <Typography variant="caption" color="text.secondary" sx={{ width: { xs: "100%", sm: "auto" } }}>
          {resultCount} resultado(s)
        </Typography>
      )}
    </Box>
  );
}